import React from 'react';
import classnames from 'classnames';

import classes from './Text.module.scss';

type TextType =
  'H1' |
  'H2' |
  'H3' |
  'H4' |
  'H5' |
  'H6' |
  'Subtitle1' |
  'Subtitle2' |
  'Body1' |
  'Body2' |
  'Small1' |
  'Small2' |
  'Small3' |
  'Button' |
  'Initials' |
  'SubMenu' |
  'Label' |
  'Caption' |
  'BreadcrumbTrail' |
  'BreadcrumbActive'

type TextProps = {
  type: TextType;
  className?: string;
  style?: any;
  onClick?: any;
  children?: any;
}

function Text({
  type,
  className = '',
  style = {},
  onClick,
  children
}: TextProps) {
  return (
    <p
      className={classnames(classes.textElement, classes[type], className)}
      style={{ ...style }}
      onClick={onClick}
    >
      {children}
    </p>
  )
};

export default Text